import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import Workflows from '../components/operations/Workflows/Workflows'
import WorkflowDetail from '../components/operations/Workflows/WorkflowDetail'
import CreateWorkflow from '../components/operations/Workflows/CreateWorkflow'
import AlertsNotifications from '../components/operations/AlertsNotifications/AlertsNotifications'
import CreateTrigger from '../components/operations/AlertsNotifications/CreateTrigger'
import Wire from '../components/operations/wire/Wire'
import CreateConversation from '../components/operations/wire/CreateConversation'
import DataVisualization from '../components/insights/DataVisualization'
import DataFilter from '../components/insights/DataFilter'
import Users from '../components/admin/Users/Users'
import CreateUser from '../components/admin/Users/CreateUser'
import CreateMultipleUsers from '../components/admin/Users/CreateMultipleUsers'
import CreateSingleUser from '../components/admin/Users/CreateSingleUser'
import UserDetail from '../components/admin/Users/UserDetail'
import Devices from '../components/admin/Devices/Devices'
import CreateDevice from '../components/admin/Devices/CreateDevice'
import CreateMobileDevice from '../components/admin/Devices/MobileDevice/CreateMobileDevice'
import EditMobileDevice from '../components/admin/Devices/MobileDevice/EditMobileDevice'
import CreateLocationTag from '../components/admin/Devices/LocationTag/CreateLocationTag'
import EditLocationTag from '../components/admin/Devices/LocationTag/EditLocationTag'
import CreateIntercom from '../components/admin/Devices/Intercom/CreateIntercom'
import EditIntercom from '../components/admin/Devices/Intercom/EditIntercom'

import ArchivedWorkflows from '../components/operations/ArchivedWorkflows/ArchivedWorkflows'
import ArchivedWorkflowDetail from '../components/operations/ArchivedWorkflows/ArchivedWorkflowDetail'

import InventoryAssets from '../components/inventory/assets/Assets'
import AssetDetail from '../components/inventory/assets/AssetDetail'
import InventoryGroups from '../components/inventory/groups/Groups'
import GroupDetail from '../components/inventory/groups/GroupDetail'

import WorkflowAttributes from '../components/admin/WorkflowAttributes/WorkflowAttributes'
import CreateWorkflowAttribute from '../components/admin/WorkflowAttributes/CreateWorkflowAttribute'
import WorkflowAttributeDetail from '../components/admin/WorkflowAttributes/WorkflowAttributeDetail'

import WorkflowGroups from '../components/admin/WorkflowGroups/WorkflowGroups'
import CreateWorkflowGroup from '../components/admin/WorkflowGroups/CreateWorkflowGroup'
import WorkflowGroupDetail from '../components/admin/WorkflowGroups/WorkflowGroupDetail'

import Organizations from '../components/stanadmin/Organizations/Organizations'
import OrganizationDetail from '../components/stanadmin/Organizations/OrganizationDetail'
import CreateOrganization from '../components/stanadmin/Organizations/CreateOrganization'
import Profile from '../components/user/Profile'

import PageNotAllowed from '../components/PageNotAllowed'

//Auth
import auth from '../components/webmaster/Authentication/auth'

import store from '../components/webmaster/Store/vuex'

var org = store.state.usermain;

Vue.use(Router)

const approuter = new Router({
  routes: [
    {
      path: "/", name: "Home", component: Home
    },
    {
      path: "/operations/workflows", name: "Workflows", component: Workflows
    },
    {
      path: "/operations/workflow/:id", name: "Workflow", component: WorkflowDetail
    },
    {
      path: "/operations/workflows/create", 
      name: "Create Workflow", 
      component: CreateWorkflow,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '1' || org['curOrg']['role'] == '2' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/operations/archivedworkflows", 
      name: "Archived Workflows", 
      component: ArchivedWorkflows,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/operations/archivedworkflow/:id", 
      name: "Archived Workflow",
      component: ArchivedWorkflowDetail,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/operations/wire", name: "Wire", component: Wire
    },
    {
      path: "/operations/wire/create", 
      name: "Create Conversation", 
      component: CreateConversation,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/inventory/assets", 
      name: "Assets", 
      component: InventoryAssets,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/inventory/assets/:id", 
      name: "Asset Detail", 
      component: AssetDetail,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/inventory/groups", 
      name: "Groups", 
      component: InventoryGroups,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/inventory/groups/:id", 
      name: "Group Detail", 
      component: GroupDetail,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/insights/datavisualization", 
      name: "Data Visualization", 
      component: DataVisualization,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/insights/reports/:id", 
      name: "Data Filter", 
      component: DataFilter,
      beforeEnter: (to, from, next) => {
        let reportId = to.path.slice(18, 19)

        if (org['curOrg']['role'] == '3') {
          next('/pagenotallowed')
        } else if ( org['curOrg']['role'] == 99 || reportId == "1" || reportId == "2" || reportId == "3") {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/users", 
      name: "Users", 
      component: Users,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/user/create", 
      name: "Create User", 
      component: CreateUser,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/user/create/singleuser", 
      name: "Create Single User", 
      component: CreateSingleUser,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/user/create/multipleusers", 
      name: "Create Multiple Users", 
      component: CreateMultipleUsers,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/user/:id", name: "User Detail", component: UserDetail
    },
    {
      path: "/admin/devices", 
      name: "Devices", 
      component: Devices,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/device/create",
      name: "Create Device", 
      component: CreateDevice,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/device/create/mobiledevice", 
      name: "Create Mobile Device", 
      component: CreateMobileDevice,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/device/edit/mobiledevice/:id", name: "Edit Mobile Device", component: EditMobileDevice
    },
    {
      path: "/admin/device/create/locationtag", 
      name: "Create Location Tag", 
      component: CreateLocationTag,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/device/edit/locationtag/:id", name: "Edit Location Tag", component: EditLocationTag
    },
    {
      path: "/admin/device/create/intercom", 
      name: "Create Intercom", 
      component: CreateIntercom,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/device/edit/intercom/:id", name: "Edit Intercom", component: EditIntercom
    },
    {
      path: "/admin/workflowattributes", 
      name: "Workflow Attributes", 
      component: WorkflowAttributes,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/workflowattribute/create", 
      name: "Create Workflow Attribute", 
      component: CreateWorkflowAttribute,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/workflowattribute/:id", 
      name: "Workflow Attribute Detail", 
      component: WorkflowAttributeDetail,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/workflowgroups", 
      name: "Workflow Groups", 
      component: WorkflowGroups,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/workflowgroup/create", 
      name: "Create Workflow Group", 
      component: CreateWorkflowGroup,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/admin/workflowgroup/:id", 
      name: "Workflow Group Detail", 
      component: WorkflowGroupDetail,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == '2' || org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/stanadmin/organizations", 
      name: "Organizations", 
      component: Organizations,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/stanadmin/organization/create", 
      name: "Create Organization", 
      component: CreateOrganization, 
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/stanadmin/organization/:id", 
      name: "Organization Detail", 
      component: OrganizationDetail,
      beforeEnter: (to, from, next) => {
        if (org['curOrg']['role'] == 99) {
          next()
        } else {
          next('/pagenotallowed')
        }
      },
    },
    {
      path: "/profile", name: "Profile", component: Profile
    },
    {
      path: "/pagenotallowed", name: "Page Not Allowed", component: PageNotAllowed
    }
  ]
});

approuter.beforeEach((to, from, next) => {
  auth.authUser().then(() => {
    next()
  })
});

export default approuter



// WEBPACK FOOTER //
// ./src/router/index.js